import { render, staticRenderFns } from "./BillingHeader.vue?vue&type=template&id=223d097d&scoped=true"
import script from "./BillingHeader.vue?vue&type=script&lang=js"
export * from "./BillingHeader.vue?vue&type=script&lang=js"
import style0 from "./BillingHeader.vue?vue&type=style&index=0&id=223d097d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223d097d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223d097d')) {
      api.createRecord('223d097d', component.options)
    } else {
      api.reload('223d097d', component.options)
    }
    module.hot.accept("./BillingHeader.vue?vue&type=template&id=223d097d&scoped=true", function () {
      api.rerender('223d097d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Billing/Components/BillingHeader.vue"
export default component.exports